import {
    getMessage,
    listMessages
} from './queries';
import {
    createMessage,
    deleteMessage,
    updateMessage,
    sendEmail as sendEmailMutation,
} from './mutations';

import { GraphQLQuery } from 'aws-amplify/api';
import {
    CreateMessage,
    DeleteMessage,
    GetMessage,
    ListMessages,
    Message,
    UpdateMessage
} from "../types.ts";
import {
    showErrorNotifications,
    showSuccessNotification
} from "../../../components/ServiceNotifications.tsx";
import {config} from "../config";
import { client } from '../../email-api-integration';


export const fetchRecords = async (
    {
        aliasId,
        tagId,
        status,
        limit = 10,
        nextToken = null
    }: {
        aliasId?: string
        tagId?: string,
        status?: string,
        limit?: number,
        nextToken?: string | null
    }) => {

    let filter = {}

    if (typeof aliasId !== 'undefined' && aliasId !== null) {
        filter = {
            ...filter,
            ...{aliasId: aliasId}
        };
    }

    if (typeof tagId !== 'undefined' && tagId !== null) {
        filter = {
            ...filter,
            ...{tagIds: [tagId]}
        }
    }

    if (typeof status !== 'undefined' && status !== null) {
        filter = {
            ...filter,
            ...{status: status}
        };
    }

    console.debug('IN FETCH RECORDS. FILTER', filter);

    try {
        const response = await client.graphql<GraphQLQuery<ListMessages>>({
                                                                              query: listMessages,
                                                                              variables: {
                                                                                  filter: filter,
                                                                                  limit: limit,
                                                                                  nextToken: nextToken
                                                                              },
                                                                          });
        const result = {
            items: response.data?.listMessages.items || [],
            nextToken: response.data?.listMessages.nextToken || null
        };
        console.log('fetchRecords returning:', { itemsCount: result.items.length, nextToken: result.nextToken });
        
        return result;
    } catch (e) {
        console.trace(e);
        return { items: [], nextToken: null };
    }
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetMessage>>({
                                                                        query: getMessage,
                                                                        variables: {id: id},
                                                                    });
    return response.data?.getMessage;
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateMessage>>({
                                                                               query: createMessage,
                                                                               variables: {input: payload},
                                                                           });
        console.debug('in the service response', response);

        showSuccessNotification(`${config.titles.singular} created`);
        return response.data?.createMessage;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const update = async (id: string, record: Message) => {

    console.debug('IN UPDATE', id, record);

    delete record.created;
    delete record.updated;
    delete record.tags;
    delete record.createdByUsername;
    delete record.managedByUsername;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateMessage>>({
                                                                               query: (updateMessage),
                                                                               variables: {input: record},
                                                                           });

        showSuccessNotification(`${config.titles.singular} updated`);
        return response.data?.updateMessage;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteMessage>>({
                                                                               query: (deleteMessage),
                                                                               variables: {input: {id: id}},

                                                                           });
        showSuccessNotification(`${config.titles.singular} deleted`);
        return response.data?.deleteMessage;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e)
    }
};

export const sendEmail = async (input: {
    aliasId: string;
    to: string[];
    subject: string;
    htmlBody?: string;
    textBody?: string;
    inReplyTo?: string;
}) => {
    try {
        const response = await client.graphql({
            query: sendEmailMutation,
            variables: { input },
        });

        const result = (response as any).data?.sendEmail;
        if (result) {
            showSuccessNotification('Email sent successfully');
        } else {
            showSuccessNotification('Email queued for sending');
        }
        return result;
    } catch (e) {
        console.trace(e);
        showErrorNotifications(e);
    }
};
